import React, { useEffect, useState } from "react";
import Link from "next/link";
import useSettings from "stores/settings";
import styled from "@emotion/styled";
import ModalVideo from "react-modal-video";
import dynamic from "next/dynamic";

const GifPlayer = dynamic(
  () => {
    return import("react-gif-player");
  },
  { ssr: false }
);

const Solution = () => {
  const settings = useSettings();
  const [isMymotionOpen, setMymotionOpen] = useState(false);
  const [isTossOpen, setTossOpen] = useState(false);
  const [isTalkheyoOpen, setTalkheyoOpen] = useState(false);
  // const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    settings.currentMenu = "solution";
    //SSR 로 인한 Hydrate error 해결용
    // setLoading(false);
  }, []);
  // if (isLoading) return <div></div>;

  return (
    <section className="section2 w-full h-full overflow-y-scroll section2_bg">
      <div className="max-w-7xl mx-auto px-2 sm:px-4 py-32">
        <ModalVideo channel="custom" isOpen={isMymotionOpen} url="/movie/mymotion_video.mp4" onClose={() => setMymotionOpen(false)} />
        <ModalVideo channel="custom" isOpen={isTossOpen} url="/movie/toss_all_market.mp4" onClose={() => setTossOpen(false)} />
        <ModalVideo channel="custom" isOpen={isTalkheyoOpen} url="/movie/talk.mp4" onClose={() => setTalkheyoOpen(false)} />
        <DevideWrap2>
          <div className="card-container m-2">
            <div className="image-container bg-gray-50 rounded-lg">
              <img src="/images/solution/ailoveschool_logo.png" alt="ailoveschool로고" />
            </div>
            <div className="card-header">
              <h4>AI Love School</h4>
              <p>
                AI LOVE SCHOOL은 복잡한 코딩 없이 드래그 앤 드롭으로 AI 앱을 쉽게 만들 수 있는 플랫폼입니다. 텍스트, 이미지, 영상 등 다양한
                기능을 통합하고, 데이터 연동과 자동화, 분석까지 지원합니다.
              </p>
            </div>
            <Link href="https://ailove.school/explore/" target="_blank" rel="noopener noreferrer">
              <div className="card-btn cursor-pointer">
                <a>바로가기</a>
              </div>
            </Link>
          </div>
          <div className="card-container m-2">
            <div className="image-container  bg-gray-50 rounded-lg">
              <img className="p-8" src="/images/project/aiso_logo.png" alt="Landscape Image" />
            </div>
            <div className="card-header">
              <h4>AISO</h4>
              <p>개발자가 인공지능 앱을 바로 등록하고 사용자는 바로 사용 가능한 인공지능 앱마켓 입니다.</p>
            </div>
            <Link href="https://aiso.ai/user/about/" target="_blank" rel="noopener noreferrer">
              <div target="_blank">
                <div className="card-btn cursor-pointer">
                  <a>바로가기</a>
                </div>
              </div>
            </Link>
          </div>
          <div className="card-container m-2">
            <div className="image-container mb-2">
              <img src="/images/solution/aiso_package_box_bg.png" alt="aiso package" />
            </div>
            <div className="card-header mb-5">
              {/* <h4>AISO Data Analysis <span className="text-blue-700">(AI 바우처 솔루션)</span></h4> */}
              {/* <p>CSV 데이터를 자동 분석하여 인공지능 학습까지 한번에 수행해 주는 AI 데이터 분석 플랫폼입니다</p> */}
              <h4>AISO Data Analysis</h4>
              <p>AI 데이터 분석 플랫폼입니다</p>
            </div>
            <Link href="https://aisodata.co.kr/about/" target="_blank" rel="noopener noreferrer">
              <div className="card-btn cursor-pointer">
                <a>바로가기</a>
              </div>
            </Link>
          </div>
          <div className="card-container m-2">
            <div className="image-container">
              <img src="/images/solution/aiphm.jpg" alt="AI PHM" />
            </div>
            <div className="card-header">
              <h4>AI PHM (아쿠아피시)</h4>
              <p>소수력 발전소에 사람 접근 및 화재를 감지하고 센서 빅데이터 수집 및 고장,발전량을 예측합니다</p>
            </div>
            <Link href="https://aquafish-proj.web.app/users/login" target="_blank" rel="noopener noreferrer">
              <div className="card-btn cursor-pointer">
                <a>바로가기</a>
              </div>
            </Link>
          </div>
          <div className="card-container m-2">
            <div className="image-container">
              <img src="/images/project/mymotion_image.jpg" alt="Mymotion Image" />
            </div>
            <div className="card-header">
              <h4>마이 모션</h4>
              <p>머신러닝 기반의 자이로 센서로부터 학습하여 다양한 모션을 감지하는 모델링 플랫폼</p>
            </div>
            <div
              className="card-btn"
              onClick={() => {
                setMymotionOpen(true);
              }}
            >
              <a href="#">소개영상</a>
            </div>
          </div>
          <div className="card-container m-2">
            <div className="image-container">
              <img src="/images/project/toss.png" className="p-16" alt="Landscape Image" />
            </div>
            <div className="card-header">
              <h4>TOSS</h4>
              <p>상대방 스마트폰 최상위 화면에 멀티미디어 콘텐츠를 송수신 할 수 있는 메신저 입니다</p>
            </div>
            <div
              className="card-btn"
              onClick={() => {
                setTossOpen(true);
              }}
            >
              <a href="#">소개영상</a>
            </div>
          </div>
          <div className="card-container m-2">
            <div className="image-container">
              <img src="/images/project/talkheyo.png" className="px-24" alt="Landscape Image" />
            </div>
            <div className="card-header">
              <h4>톡해요 메신저</h4>
              <p>고객과 소통하는 메신저로서 HTML5기반의 다양한 기능으로 익명 대화방 생성이 가능합니다</p>
            </div>
            <div
              className="card-btn"
              onClick={() => {
                setTalkheyoOpen(true);
              }}
            >
              <a href="#">소개영상</a>
            </div>
          </div>
          <div className="card-container m-2">
            <div className="image-container">
              <GifPlayer gif="/images/solution/hanabank_toktok.gif" className="px-28" still="/images/project/toss.png" autoplay />
            </div>
            <div className="card-header">
              <h4>하나은행</h4>
              <p>하나멤버스 앱 내 마이모션/똑똑 결제 기능 제공</p>
            </div>
          </div>
          <div className="card-container m-2">
            <div className="image-container">
              <img src="/images/solution/cleantopia-shop.png" alt=" Cleantopia Image" />
            </div>
            <div className="card-header">
              <h4>CRM 솔루션</h4>
              <p>PAD와 PC Agent 사이에 유무선 통신 기능을 제공 (전국 2,000여개 크린토피아 매장에 설치)</p>
            </div>
          </div>

          <div className="card-container m-2">
            <div className="image-container">
              <img src="/images/solution/eyegalaxy.png" className="p-0" alt="Landscape Image" />
            </div>
            <div className="card-header">
              <h4>Eye Galaxy</h4>
              <p>눈 인식 및 스마트폰과의 자동 거리 측정을 활용한 </p>
              <p>최적의 화면 제공 기술(삼성전자에 기술 제공)</p>
            </div>
          </div>
        </DevideWrap2>
      </div>
    </section>
  );
};

export default Solution;

const DevideWrap2 = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  > .card-container {
    width: calc(100% / 3 - 1rem);
  }

  @media (max-width: 1024px) {
    margin: 0 auto;
    > .card-container {
      width: calc(100% / 2 - 1rem);
    }
  }
  @media (max-width: 540px) {
    display: block;
    margin: 0 auto;
    > .card-container {
      margin: 1rem 0;
      width: 100%;
    }
  }
`;
